// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "Content/" + chunkId + "-" + "429be677181e931bd77f" + ".css";
};